<template>
  <img
    :src="src"
    alt=""
    class="lilo-mark"
    :class="size"
  />
</template>

<script>
export default {
  name: 'BrandLogo',
  props: {
    variant: {
      type: String,
      default: 'on-light',
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    src() {
      return this.variant === 'on-dark'
        ? require('@/assets/images/logos/lilo-on-dark.png')
        : require('@/assets/images/logos/lilo.png')
    },
  },
}
</script>

<style scoped>
.lilo-mark {
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
  object-position: left center;
}
.sm { height: 28px; width: auto; }
.md { height: 36px; width: auto; }
.lg { height: 48px; width: auto; }
.xl { height: 64px; width: auto; }
</style>
